import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import {
  GenericClearStore,
  GenericSetState,
  GenericSetStates
} from "@/store/helpers";
import { RaterAccountsMutations, RaterAccountsState, StateKeys } from "./types";
import { defaultState } from "./state";

export const mutations: DefineMutations<
  RaterAccountsMutations,
  RaterAccountsState
> = {
  [types.SET_STATE]: GenericSetState<RaterAccountsState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<RaterAccountsState>(),
  [types.CLEAR_RATER_ACCOUNTS_STORE]: GenericClearStore<RaterAccountsState>(
    defaultState()
  )
};
